module.exports = __webpack_public_path__ + "static/media/clutchLogin.d54b8d24.webp";